let Color = {
    red: 'r',
    blue: 'b',
    green: 'g',
    yellow: 'y',
    brown: 'br',
    pink: 'p',
    mint: 'm',
    violet: 'v',
    orange: 'o'
};

export default Color;



/** WEBPACK FOOTER **
 ** ./src/Model/Color.js
 **/